function FlagModule() {
    var self = this;
    var baseUrl = '/api/v2/flags';
    self.index = function (entityType, entityId) {
        return rest('GET', `${baseUrl}?entityId=${entityId}&type=${entityType}`);
    };

    self.ids = function (entityType, userId) {
        return rest('GET', `${baseUrl}/ids/${entityType}/${userId}`);
    };

    self.store = function (entityType, entityId) {
        var data = {
            type: entityType,
            id: entityId
        };

        return rest('POST', baseUrl, data)
            .then(function (response) {
                self.executeResponseStatus(response, entityType);
                return response;
            })
            .catch(function (response) {
                return response;
            });
    };

    self.show = function (entityType, entityId, userId) {
        if (userId)
            return rest('GET', `${baseUrl}/${entityId}?type=${entityType}&userId=${userId}`);
        return rest('GET', `${baseUrl}/${entityId}?type=${entityType}`);
    };

    self.delete = function (entityType, entityId, userId) {
        var data = {
            type: entityType,
            userId: userId
        };
        return rest('DELETE', `${baseUrl}/${entityId}`, data).then(function (response) {
            return response;
        });
    };

    self.enabling = function (flagId) {
        var data = {
            enabled: true
        };
        return rest('PUT', `${baseUrl}/${flagId}`, data)
            .then(function (response) {
                return response;
            });
    };

    self.blocking = function (flagId, blocked) {
        var data = {
            blocked: typeof blocked !== 'undefined' ? blocked : true,
        };
        return rest('PUT', `${baseUrl}/${flagId}`, data)
            .then(function (response) {
                return response;
            });
    };


    self.count = function (entityType, userId) {
        return rest('GET', `${baseUrl}/count/${entityType}/${userId}`);
    };

    self.executeResponseStatus = function (response, entityType) {
        switch (response.status) {
            //@TODO mettere messaggio per NUMBER_MAX_FANS_ID
            case 'flag.flags.limit':
                Swal.fire({
                    width: 600,
                    showConfirmButton: false,

                    html:
                        `<h2><i class="fa fa-frown-o text-danger" aria-hidden="true"></i> Oops...posti terminati nel tuo food network!</h2><div class="text-left"><p>Non puoi diventare Fan di nuove Attività, avendo già utilizzato i ${response.data.base} "posti" inclusi nel tuo piano e i ${response.data.extra} posti "bonus" (guadagnati con gli inviti) disponibili a oggi nel tuo food network.</p><p>Per diventare Fan di nuove Attività puoi scegliere tra queste 3 opzioni:</p><ul><li>Rinunci ad essere Fan di un'<a href="/user/favorite/caterings">Attività già presente nel tuo food network</a> e liberi così un posto per la nuova Attività di cui preferisci essere da ora Fan</li><li>Guadagni posti "bonus" invitando un nuovo Utente (ad es. un <a href="/user/favorite/users#invite">amico</a>, o un'<a href="/user/favorite/caterings#locali">Attività</a> che ti piace) su TrovaciGusto con il tuo codice invito: al momento della sua iscrizione riceverai un'email e una notifica e il tuo food network diventerà più "capiente", rispettivamente, di un posto bonus se hai invitato una Persona, e di 5 posti bonus se hai invitato un'Attività, così ad esempio, partendo dai ${response.data.base} posti iniziali del tuo profilo, dopo la prima Persona invitata potrai essere Fan di ${parseInt(response.data.base) + 1} Attività in contemporanea, alla seconda invitata di ${parseInt(response.data.base) + 2} , se poi inviti un'Attività arrivi a ${parseInt(response.data.base) + 7} posti di "capienza" nel tuo food network, e così via.</li><li>Se gestisci un'<a href="https://trovacigusto.com/user/favorite/caterings#activity">Attività food tradizionale o vuoi divertirti/guadagnare gestendone una "virtuale"</a>, puoi rimanere sul piano attuale e aumentare i tuoi posti invitando anche Clienti e Fornitori (vedi punto precedente), o aumentare subito i posti disponibili nel tuo food network sbloccando il piano <a target="_blank" href="https://blog.trovacigusto.com/prodotto/piano-sistema-premium-mese/">Premium</a>.</li> </ul></div>`
                });
                break;
            case 'flag.flaggable.limit':
                pNotify(`Ci dispiace, al momento non puoi diventare Fan poiché il Fan club digitale di ${response.data.name} ha esaurito i posti a disposizione`, 'warning');
                break;
            case 'flag.add.self':
                pNotify('Non puoi diventare follower di te stesso', 'warning');
                break;
            case 'flag.exist':
                pNotify('Già presente.');
                break;
            case 'flag.queue':
                pNotify(`La tua richiesta di accesso al Fan Club di ${response.data.name} è stata inviata all'Attività ed è in attesa di essere approvata.`, 'warning')
                break;
            case 'flags.created':
                pNotify(`La tua richiesta di accesso al Fan Club di ${response.data.name} è stata inviata all'Attività ed è in attesa di essere approvata.`, 'warning')
                break;
            case 'flag.blocked':
                pNotify(`Ci dispiace, non puoi diventare Fan di ${response.data.name}, risulti inserito nella sua blacklist, se è un errore contatta direttamente l'Attività per essere rimosso dalla blacklist e poterne così diventare Fan.`, 'danger')
                break;
            default:
                if (response.success) {
                    switch (entityType) {
                        case'catering':
                            pNotify(`Ora sei Fan di ${response.data.name}`);
                            break;
                        case'offer':
                            /* pNotify('Ora Mi Piace questa Proposta', 'success', 2000);*/
                            break;
                        case'user':
                            pNotify(`Ora sei Follower di ${response.data.name}`, 'success', 2000);
                            break;
                    }
                }
                if (!response.success)
                    pNotify('C\'è stato un problema!', 'error');
        }

    };


    return self;
}